import { render, staticRenderFns } from "./DeclaracaoCartorio.vue?vue&type=template&id=5285c486&scoped=true&"
import script from "./DeclaracaoCartorio.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoCartorio.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoCartorio.vue?vue&type=style&index=0&id=5285c486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5285c486",
  null
  
)

export default component.exports